module.exports = __webpack_public_path__ + "static/img/qdhf5.cd255b4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xinqingBrand/assets/qdhf5.jpg
// module id = 95Zq
// module chunks = 0